import React from 'react';
import { galleryItems } from '../data/content';
import { practice } from '../data/site';
import { SectionLabel } from './ui/SectionLabel';
import { Reveal } from './ui/Reveal';
const spanClass = {
  wide: 'lg:col-span-7',
  tall: 'lg:col-span-5',
  normal: 'lg:col-span-4',
  full: 'lg:col-span-12'
} as const;
const ratioClass = {
  wide: 'aspect-[3/2]',
  tall: 'aspect-[4/5]',
  normal: 'aspect-[4/3]',
  full: 'aspect-[16/9] lg:aspect-[21/9]'
} as const;
export function ClinicGallery() {
  return <section id="clinic" className="scroll-mt-24 bg-paper-off py-24 lg:py-40" data-id="element-156" data-mp="2zb5omdg2ecy6">
      <div className="mx-auto max-w-shell px-5 sm:px-8 lg:px-12" data-id="element-157" data-mp="3d9vmvwemeio4">
        <Reveal className="max-w-[760px]" data-id="element-158" data-mp="3d80y2708a6er">
          <SectionLabel data-id="element-159" data-mp="3980l6qss239t">Lima Dental Miami Lakes</SectionLabel>
          <h2 className="font-display mt-6 text-[clamp(2rem,4.2vw,3.3rem)] leading-[1.06] text-ink" data-id="element-160" data-mp="39awjwhcg8vzb">
            A local practice. A place
            <br data-id="element-161" data-mp="oj2rsvryiyto" />
            designed to feel comfortable.
          </h2>
          <p className="mt-6 max-w-[54ch] text-[16.5px] leading-[1.8] text-ink/65" data-id="element-162" data-mp="1lcelf5snmazy">
            Our office is at {practice.fullAddress}, with easy parking and direct access for new
            and existing patients.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-4 lg:mt-20 lg:grid-cols-12 lg:gap-5" data-id="element-163" data-mp="1uee2tz7kzh3f">
          {galleryItems.map((item, index) => <Reveal key={item.src} delay={Math.min(index, 3) * 0.06} className={`${spanClass[item.span]} group`} data-id="element-164" data-mp="1za36oeqmvk5j" data-mpi={index}>
              <figure className="h-full" data-id="element-165" data-mp="16obenu6seva3">
                <div className={`overflow-hidden rounded-[10px] bg-paper-line ${ratioClass[item.span]}`} data-id="element-166" data-mp="16l5n88aorhb7">
                  <img src={item.src} alt={item.alt} loading="lazy" className={`h-full w-full object-cover ${item.position} saturate-[0.5] contrast-[1.04] transition-transform duration-[900ms] ease-out group-hover:scale-[1.03]`} data-id="element-167" data-mp="1gdbgrmgl66si" />
                </div>
                <figcaption className="mt-3 flex items-center gap-2.5 text-[13px] tracking-wide text-ink/50" data-id="element-168" data-mp="1r6mxlj0wjoq0">
                  <span aria-hidden="true" className="h-px w-5 bg-accent" data-id="element-169" data-mp="1m8bmz62s9a6q" />
                  {item.caption}
                </figcaption>
              </figure>
            </Reveal>)}
        </div>
      </div>
    </section>;
}